<template>
  <div>
    <el-dialog
      :show-close="false"
      fullscreen
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body
      custom-class="cs-modal"
    >
      <template slot="title">
        <div class="flex justify-start">
          <div class="flex gap-4 items-center cursor-pointer">
            <svg
              @click="handleClose"
              class="cursor-pointer"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.41406 12.657L12.3641 16.607C12.5417 16.7964 12.6387 17.0475 12.6345 17.3072C12.6303 17.5669 12.5252 17.8148 12.3415 17.9983C12.1578 18.1819 11.9098 18.2868 11.6501 18.2909C11.3905 18.2949 11.1394 18.1977 10.9501 18.02L5.29306 12.364C5.19987 12.2713 5.12592 12.1611 5.07546 12.0398C5.025 11.9185 4.99902 11.7884 4.99902 11.657C4.99902 11.5256 5.025 11.3954 5.07546 11.2741C5.12592 11.1528 5.19987 11.0426 5.29306 10.95L10.9501 5.29296C11.0423 5.19745 11.1526 5.12127 11.2747 5.06886C11.3967 5.01645 11.5279 4.98886 11.6607 4.98771C11.7934 4.98655 11.9251 5.01186 12.048 5.06214C12.1709 5.11242 12.2826 5.18667 12.3765 5.28056C12.4703 5.37446 12.5446 5.48611 12.5949 5.60901C12.6452 5.7319 12.6705 5.86358 12.6693 5.99636C12.6682 6.12914 12.6406 6.26036 12.5882 6.38236C12.5358 6.50437 12.4596 6.61471 12.3641 6.70696L8.41406 10.657H18.0001C18.2653 10.657 18.5196 10.7623 18.7072 10.9499C18.8947 11.1374 19.0001 11.3917 19.0001 11.657C19.0001 11.9222 18.8947 12.1765 18.7072 12.3641C18.5196 12.5516 18.2653 12.657 18.0001 12.657H8.41406Z"
                fill="black"
              />
            </svg>
            <h2 class="text-3xl font-bold text-start m-0 px-4 text-black">{{ circle&&circle.name }}</h2>
          </div>
        </div>
        <el-divider class="mt-2 mb-0" />
      </template>
      <div v-if="hasVideo||isAdminAddVideo">
        <!-- <div v-if="!isAdd" class="flex justify-end items-center">
          <button
            @click="handleTriggerAddVideo(true)"
            class="btn hover:bg-blue-900 bg-blue-900 text-white h-9"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 12.75V21.75H12.75V12.75H21.75V11.25H12.75V2.25L11.25 2.25V11.25H2.25V12.75H11.25Z"
                fill="white"
              />
            </svg>
            {{ $t('Thêm Video') }}
          </button>
        </div>-->
        <div
          v-if="isAdd"
          v-loading="isLoading"
          class="flex flex-col gap-2 bg-gray-200 p-2 text-black"
        >
          <div class="fs-18 font-bold mb-2">{{ $t('lbl_update_video_playlist') }}</div>
          <div v-for="(video,index) in addVideo" :key="index" class="flex gap-2 items-center">
            <div class="flex flex-col md:flex-row items-center gap-2 w-full">
              <el-input
                class="flex-1"
                :placeholder="$t('lbl_enter_title_video')"
                v-model="video.name"
              ></el-input>
              <el-input
                class="flex-1"
                :placeholder="$t('lbl_enter_link_video')"
                v-model="video.url"
              >
                <template slot="append">
                  <div
                    @click="handleTriggerUpload(index)"
                    class="w-full h-full cursor-pointer flex items-center justify-center"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="$t('lbl_upload_video')"
                      placement="top"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 15.5913 0.632141 17.1174 1.75736 18.2426C2.88258 19.3679 4.4087 20 6 20H19C19.6566 20 20.3068 19.8707 20.9134 19.6194C21.52 19.3681 22.0712 18.9998 22.5355 18.5355C22.9998 18.0712 23.3681 17.52 23.6194 16.9134C23.8707 16.3068 24 15.6566 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C4.93913 18 3.92172 17.5786 3.17157 16.8284C2.42143 16.0783 2 15.0609 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 15.7956 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7956 18 19 18ZM8 13H10.55V16H13.45V13H16L12 9L8 13Z"
                          fill="#20409B"
                        />
                      </svg>
                    </el-tooltip>
                  </div>
                </template>
              </el-input>

              <div style="width:fit-content;min-width:150px" class="flex gap-2">
                <div @click="()=>video.is_show=video.is_show===1?2:1" class="cs-button-hide">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t(video.is_show===1?'lbl_hide_video_for_members':'lbl_show_video_for_members')"
                    placement="top"
                  >
                    <svg
                      v-if="video.is_show===1"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.9402 6.08019C11.2909 6.02642 11.6453 5.99967 12.0002 6.00019C15.1802 6.00019 18.1702 8.29018 19.9102 12.0002C19.6441 12.5648 19.3435 13.1125 19.0102 13.6402C18.9044 13.804 18.8487 13.9952 18.8502 14.1902C18.8524 14.4084 18.926 14.6199 19.0596 14.7925C19.1933 14.965 19.3798 15.089 19.5905 15.1457C19.8013 15.2024 20.0248 15.1885 20.227 15.1063C20.4291 15.024 20.5988 14.8779 20.7102 14.6902C21.1761 13.9581 21.5808 13.1888 21.9202 12.3902C21.9738 12.2654 22.0015 12.131 22.0015 11.9952C22.0015 11.8594 21.9738 11.725 21.9202 11.6002C19.9002 6.91019 16.1002 4.00019 12.0002 4.00019C11.5309 3.99782 11.0623 4.03798 10.6002 4.12019C10.4689 4.14251 10.3432 4.19048 10.2304 4.26136C10.1177 4.33224 10.0199 4.42464 9.94287 4.53329C9.8658 4.64193 9.81088 4.76469 9.78125 4.89456C9.75162 5.02443 9.74786 5.15886 9.77018 5.29019C9.79251 5.42151 9.84048 5.54715 9.91136 5.65993C9.98224 5.77271 10.0746 5.87043 10.1833 5.9475C10.2919 6.02457 10.4147 6.07949 10.5446 6.10912C10.6744 6.13875 10.8089 6.14251 10.9402 6.12019V6.08019ZM3.71019 2.29019C3.61695 2.19695 3.50626 2.12299 3.38443 2.07253C3.26261 2.02207 3.13204 1.99609 3.00019 1.99609C2.86833 1.99609 2.73776 2.02207 2.61594 2.07253C2.49411 2.12299 2.38342 2.19695 2.29019 2.29019C2.10188 2.47849 1.99609 2.73388 1.99609 3.00019C1.99609 3.26649 2.10188 3.52188 2.29019 3.71019L5.39019 6.80019C3.97576 8.16171 2.85004 9.79417 2.08019 11.6002C2.02512 11.7264 1.9967 11.8625 1.9967 12.0002C1.9967 12.1378 2.02512 12.274 2.08019 12.4002C4.10019 17.0902 7.90019 20.0002 12.0002 20.0002C13.7973 19.9878 15.552 19.4527 17.0502 18.4602L20.2902 21.7102C20.3831 21.8039 20.4937 21.8783 20.6156 21.9291C20.7375 21.9798 20.8682 22.006 21.0002 22.006C21.1322 22.006 21.2629 21.9798 21.3848 21.9291C21.5066 21.8783 21.6172 21.8039 21.7102 21.7102C21.8039 21.6172 21.8783 21.5066 21.9291 21.3848C21.9798 21.2629 22.006 21.1322 22.006 21.0002C22.006 20.8682 21.9798 20.7375 21.9291 20.6156C21.8783 20.4937 21.8039 20.3831 21.7102 20.2902L3.71019 2.29019ZM10.0702 11.4802L12.5202 13.9302C12.3512 13.9787 12.176 14.0022 12.0002 14.0002C11.4698 14.0002 10.961 13.7895 10.586 13.4144C10.2109 13.0393 10.0002 12.5306 10.0002 12.0002C9.99814 11.8244 10.0217 11.6492 10.0702 11.4802ZM12.0002 18.0002C8.82018 18.0002 5.83019 15.7102 4.10019 12.0002C4.74627 10.5739 5.66326 9.28676 6.80019 8.21019L8.57019 10.0002C8.15443 10.759 7.99592 11.6321 8.11844 12.4886C8.24096 13.3452 8.6379 14.1388 9.24971 14.7507C9.86152 15.3625 10.6552 15.7594 11.5117 15.8819C12.3682 16.0044 13.2414 15.8459 14.0002 15.4302L15.5902 17.0002C14.5013 17.6411 13.2636 17.9858 12.0002 18.0002Z"
                        fill="#e09030"
                      />
                    </svg>
                    <svg
                      v-else
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.9201 11.6C19.9001 6.91 16.1001 4 12.0001 4C7.90007 4 4.10007 6.91 2.08007 11.6C2.025 11.7262 1.99658 11.8623 1.99658 12C1.99658 12.1377 2.025 12.2738 2.08007 12.4C4.10007 17.09 7.90007 20 12.0001 20C16.1001 20 19.9001 17.09 21.9201 12.4C21.9751 12.2738 22.0036 12.1377 22.0036 12C22.0036 11.8623 21.9751 11.7262 21.9201 11.6ZM12.0001 18C8.83007 18 5.83007 15.71 4.10007 12C5.83007 8.29 8.83007 6 12.0001 6C15.1701 6 18.1701 8.29 19.9001 12C18.1701 15.71 15.1701 18 12.0001 18ZM12.0001 8C11.2089 8 10.4356 8.2346 9.77779 8.67412C9.11999 9.11365 8.6073 9.73836 8.30455 10.4693C8.0018 11.2002 7.92258 12.0044 8.07693 12.7804C8.23127 13.5563 8.61223 14.269 9.17164 14.8284C9.73105 15.3878 10.4438 15.7688 11.2197 15.9231C11.9956 16.0775 12.7999 15.9983 13.5308 15.6955C14.2617 15.3928 14.8864 14.8801 15.3259 14.2223C15.7655 13.5645 16.0001 12.7911 16.0001 12C16.0001 10.9391 15.5786 9.92172 14.8285 9.17157C14.0783 8.42143 13.0609 8 12.0001 8ZM12.0001 14C11.6045 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3037 13.1308 10.1523 12.7654C10.0009 12.3999 9.96133 11.9978 10.0385 11.6098C10.1157 11.2219 10.3061 10.8655 10.5859 10.5858C10.8656 10.3061 11.2219 10.1156 11.6099 10.0384C11.9978 9.96126 12.4 10.0009 12.7654 10.1522C13.1309 10.3036 13.4432 10.56 13.663 10.8889C13.8828 11.2178 14.0001 11.6044 14.0001 12C14.0001 12.5304 13.7894 13.0391 13.4143 13.4142C13.0392 13.7893 12.5305 14 12.0001 14Z"
                        fill="#e09030"
                      />
                    </svg>
                  </el-tooltip>
                </div>
                <div
                  @click="handleRemoveVideo(index)"
                  v-if="index!==0||addVideo.length>1"
                  class="cs-button-delete"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('lbl_remove_video')"
                    placement="top"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z"
                        fill="#EA5455"
                      />
                    </svg>
                  </el-tooltip>
                </div>
                <div v-if="index===addVideo.length-1" @click="handleAddVideo" class="cs-button-add">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('lbl_add_video')"
                    placement="top"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11 13V22H13V13H22V11H13V2L11 2V11H2V13H11Z" fill="#20409B" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>
              <input
                v-show="false"
                :ref="`upload-file-${index}`"
                type="file"
                accept="video/mp4, video/x-m4v, video/*"
                @change="(e)=>handleChangeFile(e,video)"
              />
            </div>
          </div>
          <div class="ml-auto flex gap-2 items-center justify-between mt-2">
            <button
              @click="handleTriggerAddVideo(false)"
              :disabled="isLoading"
              class="fs-14 flex items-center justify-center border-0 focus:outline-none bg-indigo-50 text-gray-600 rounded h-9 px-4"
            >
              <div>{{ $t('lbl_cancel') }}</div>
            </button>

            <button
              @click="handleSubmitAddVideo"
              :disabled="isLoading"
              class="fs-14 flex items-center justify-center border-0 focus:outline-none bg-blue-900 text-white rounded h-9 px-4"
            >
              <div>{{ $t('lbl_save') }}</div>
            </button>
          </div>
        </div>
        <div class="row cs-video-container mt-2">
          <div :class="zoomVideo?'col-12 cs-max-height':'col-8'">
            <div class="h-full">
              <div class="bg-gray-50 flex items-center">
                <!-- <div
                class="bg-gray-100 hover:bg-gray-200 ml-auto cursor-pointer p-2 border transition-all duration-200"
                @click.stop="toggleZoomVideo"
              >
                <span class="inline-block w-6 h-6 mr-2">
                  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1_1_2" fill="white">
                      <path
                        d="M0 41C0 38.7909 1.79086 37 4 37H38V77H4C1.79086 77 0 75.2091 0 73V41Z"
                      />
                    </mask>
                    <path
                      d="M0 41C0 38.7909 1.79086 37 4 37H38V77H4C1.79086 77 0 75.2091 0 73V41Z"
                      stroke="currentColor"
                      stroke-width="16"
                      mask="url(#path-1-inside-1_1_2)"
                    />
                    <mask id="path-2-inside-2_1_2" fill="white">
                      <path
                        d="M30 26C30 23.7909 31.7909 22 34 22H96C98.2091 22 100 23.7909 100 26V73C100 75.2091 98.2091 77 96 77H30V26Z"
                      />
                    </mask>
                    <path
                      d="M30 26C30 23.7909 31.7909 22 34 22H96C98.2091 22 100 23.7909 100 26V73C100 75.2091 98.2091 77 96 77H30V26Z"
                      stroke="currentColor"
                      stroke-width="16"
                      mask="url(#path-2-inside-2_1_2)"
                    />
                  </svg>
                </span>
                <span v-if="!zoomVideo">{{ $t('lbl_cinema_mode') }}</span>
                <span v-else>{{ $t('lbl_default_mode') }}</span>
                </div>-->
              </div>
              <video-player
                class="video-player-box h-full"
                ref="CircleVideoPlayer"
                :options="playerOptions"
                @play="onPlayerPlay($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
                @loadeddata="onPlayerLoadeddata($event)"
                @waiting="onPlayerWaiting($event)"
                @playing="onPlayerPlaying($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @canplay="onPlayerCanplay($event)"
                @canplaythrough="onPlayerCanplaythrough($event)"
                @statechanged="playerStateChanged($event)"
                @ready="playerReadied"
              ></video-player>
            </div>
          </div>
          <div :class="zoomVideo?'col-12 mt-4':'col-4'">
            <div
              class="font-bold fs-18 p-2 bg-gray-200 rounded-md flex items-center justify-between"
            >
              <span>{{ $t('lbl_video_playlist') }}</span>
              <el-tooltip
                v-if="isAdmin"
                class="item"
                effect="dark"
                :content="$t('lbl_update_video_playlist')"
                placement="top"
              >
                <svg
                  v-if="isAdmin"
                  @click="handleUpdateVideo"
                  class="cursor-pointer"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 11.9999C20.7348 11.9999 20.4804 12.1053 20.2929 12.2928C20.1054 12.4804 20 12.7347 20 12.9999V18.9999C20 19.2652 19.8946 19.5195 19.7071 19.707C19.5196 19.8946 19.2652 19.9999 19 19.9999H5C4.73478 19.9999 4.48043 19.8946 4.29289 19.707C4.10536 19.5195 4 19.2652 4 18.9999V4.99994C4 4.73472 4.10536 4.48037 4.29289 4.29283C4.48043 4.1053 4.73478 3.99994 5 3.99994H11C11.2652 3.99994 11.5196 3.89458 11.7071 3.70705C11.8946 3.51951 12 3.26516 12 2.99994C12 2.73472 11.8946 2.48037 11.7071 2.29283C11.5196 2.1053 11.2652 1.99994 11 1.99994H5C4.20435 1.99994 3.44129 2.31601 2.87868 2.87862C2.31607 3.44123 2 4.20429 2 4.99994V18.9999C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 21.9999 5 21.9999H19C19.7956 21.9999 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 18.9999V12.9999C22 12.7347 21.8946 12.4804 21.7071 12.2928C21.5196 12.1053 21.2652 11.9999 21 11.9999ZM6 12.7599V16.9999C6 17.2652 6.10536 17.5195 6.29289 17.707C6.48043 17.8946 6.73478 17.9999 7 17.9999H11.24C11.3716 18.0007 11.5021 17.9755 11.6239 17.9257C11.7457 17.8759 11.8566 17.8026 11.95 17.7099L18.87 10.7799L21.71 7.99994C21.8037 7.90698 21.8781 7.79637 21.9289 7.67452C21.9797 7.55266 22.0058 7.42195 22.0058 7.28994C22.0058 7.15793 21.9797 7.02722 21.9289 6.90536C21.8781 6.7835 21.8037 6.6729 21.71 6.57994L17.47 2.28994C17.377 2.19621 17.2664 2.12182 17.1446 2.07105C17.0227 2.02028 16.892 1.99414 16.76 1.99414C16.628 1.99414 16.4973 2.02028 16.3754 2.07105C16.2536 2.12182 16.143 2.19621 16.05 2.28994L13.23 5.11994L6.29 12.0499C6.19732 12.1434 6.12399 12.2542 6.07423 12.376C6.02446 12.4979 5.99924 12.6283 6 12.7599ZM16.76 4.40994L19.59 7.23994L18.17 8.65994L15.34 5.82994L16.76 4.40994ZM8 13.1699L13.93 7.23994L16.76 10.0699L10.83 15.9999H8V13.1699Z"
                    fill="#20409B"
                  />
                </svg>
              </el-tooltip>
            </div>
            <div class="flex flex-col gap-2 mt-2 overflow-y-scroll py-2" style="height:70vh">
              <div
                v-for="(videoItem,index) in videoShow"
                :key="index"
                @click="handleUpdateSrcPlayer(videoItem)"
                class="cs-video-item"
              >
                <div class="flex items-center gap-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 5C2 4.44771 2.44771 4 3 4H21C21.5523 4 22 4.44771 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44771 20 2 19.5523 2 19V5Z"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18 4V20"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6 4V20"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 9H22"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 15H22"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 9H5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 8V10"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.5 4H7.5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.5 20H7.5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.5 4H19.5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.5 20H19.5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 15H5"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 14V16"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 14V16"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 8V10"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.5 9.5L14.5 12L10.5 14.5V9.5Z"
                      stroke="#20409B"
                      stroke-width="2"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span class="fs-16 italic">{{ videoItem.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="flex flex-col items-center">
        <h2
          class="fs-24 font-bold text-center mt-4"
        >{{ $t(isAdmin?'lbl_circle_does_not_have_videos_admin':'lbl_circle_does_not_have_videos') }}</h2>
        <div v-if="isAdmin" class="flex justify-end items-center">
          <button
            @click="handleTriggerAddVideo(true,true)"
            class="btn hover:bg-blue-900 bg-blue-900 text-white h-9"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 12.75V21.75H12.75V12.75H21.75V11.25H12.75V2.25L11.25 2.25V11.25H2.25V12.75H11.25Z"
                fill="white"
              />
            </svg>
            {{ $t('lbl_add_video') }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import 'videojs-resolution-switcher'
import 'videojs-resolution-switcher/lib/videojs-resolution-switcher.css'
import 'videojs-watermark'

import liveStream from '@/assets/images/livestream.png'
import { videoPlayer } from 'vue-video-player'
import appUtils from '../../utils/appUtils'
import uploadCircleFile from '../../utils/uploadCircleFile'

const DEFAULT_VIDEO = {
  name: '',
  url: '',
  file: '',
  is_show: 1
}

export default {
  name: 'CircleVideoList',
  components: { videoPlayer },
  props: {
    circle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAdmin: Boolean,
    isMember: Boolean
  },
  data () {
    return {
      isLoading: false,
      dialogVisible: false,
      video_url: '',
      zoomVideo: false,
      playerSources: [],
      playerOptions: {
        muted: false,
        language: this.$lang,
        plugins: {
          videoJsResolutionSwitcher: {
            ui: true,
            default: 3,
            dynamicLabel: true
          }
        },
        playbackRate: 1,
        playbackRates: [0.7, 1.0, 1.5, 2.0]
      },
      isSubmittingPublicShowVideo: false,
      isPublicShowVideo: false,
      liveStream,
      isAdd: false,
      addVideo: [
        {
          ...DEFAULT_VIDEO
        }
      ],
      videoData: [],
      isAdminAddVideo: false
    }
  },
  computed: {
    player () {
      return this.$refs.CircleVideoPlayer
    },
    videoShow () {
      if (this.isAdmin) {
        return this.videoData
      } else {
        return this.videoData?.filter(item => item?.is_show === 2)
      }
    },
    hasVideo () {
      const isAdminVideo = this.isAdmin && this.videoData?.length
      const isMemberVideo = this.isMember && this.videoShow?.length

      return isAdminVideo || isMemberVideo
    }
  },
  methods: {
    openModal (show) {
      this.dialogVisible = show
      if (!show) return

      this.getVideosCircle()

      if (!window) return
      window.addEventListener('keypress', event => {
        console.log(event)
        if (event?.keyCode === 116 && event.target.nodeName !== 'INPUT') {
          this.zoomVideo = !this.zoomVideo
        }
      })
    },
    handleClose () {
      if (this.$refs.CircleVideoPlayer && this.$refs.CircleVideoPlayer.player) {
        this.$refs.CircleVideoPlayer.player.pause()
      }

      //   this.player.player.reset()
      this.dialogVisible = false
      this.addVideo = [
        {
          ...DEFAULT_VIDEO
        }
      ]
    },
    onPlayerPlay (player) {},
    onPlayerPause (player) {},
    onPlayerEnded (player) {},
    onPlayerTimeupdate (player) {},
    onPlayerLoadeddata (player) {},
    onPlayerWaiting (player) {},
    onPlayerPlaying (player) {},
    onPlayerCanplay (player) {},
    onPlayerCanplaythrough (player) {},
    playerStateChanged (playerCurrentState) {},
    playerReadied (player) {
      if (player.watermark && this.videoShow?.[0]?.url) {
        player.watermark({
          image: this.circle?.logo || 'https://hodo.app/hodologo_256x256.png'
        })
      }
      if (player.updateSrc && this.videoShow?.[0]?.url) {
        this.playerSources = [
          {
            src: this.videoShow?.[0]?.url,
            type: 'video/mp4',
            label: 'HD',
            res: 720
          }
        ]
        player.updateSrc(this.playerSources)
        player.on('resolutionchange', function () {
          console.info('Source changed to %s', player.src())
        })
      }
    },
    toggleZoomVideo () {
      this.zoomVideo = !this.zoomVideo
    },

    handleTriggerAddVideo (show, isAdminAdd = false) {
      this.isAdd = show
      this.isAdminAddVideo = isAdminAdd
    },
    handleAddVideo () {
      this.addVideo.push({
        ...DEFAULT_VIDEO
      })
    },
    handleRemoveVideo (index) {
      this.addVideo.splice(index, 1)
    },
    handleTriggerUpload (index) {
      this.$refs[`upload-file-${index}`][0].click()
    },
    handleChangeFile (e, video) {
      const file = e.target.files?.[0]
      if (!file) return
      const isVideo = appUtils.isVideo(file?.name)

      if (!isVideo) {
        this.$toast.open({
          message: this.$t('msg_please_select_file_type_video'),
          type: 'warning'
        })
      }

      video.file = file
      video.url = file.name
    },
    async handleSubmitAddVideo () {
      try {
        if (!this.circle?.id) return
        const isValidAllVideo =
          this.addVideo?.length &&
          this.addVideo.every(item => item.name && item.url)

        if (!isValidAllVideo) {
          this.$toast.open({
            message: this.$t('msg_please_enter_all_title_link_video'),
            type: 'warning'
          })

          return
        }
        this.isLoading = true

        // const medias = await this.handleUploadFiles(this.addVideo)
        const medias = await this.handleUploadFilesAWS(this.addVideo)

        const params = {
          circle_id: this.circle.id,
          medias
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .postUploadVideosCircle(params)

        this.$toast.open({
          message: this.$t('lbl_save_video_success'),
          type: 'success'
        })

        this.handleRefresh()
      } catch (error) {
        console.log(error)

        this.$toast.open({
          message: this.$t('lbl_save_video_fail'),
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleUploadFiles (data) {
      if (!data?.length) return []

      try {
        const fileUrls = await Promise.all(
          data?.map(async video => {
            if (video?.id || !video?.file) {
              return video
            }

            const params = {
              file: video.file
              // FolderTarget: 'emr_master',
              // IdTarget: this.circle.id
            }
            const formData = new FormData()
            for (const key in params) {
              formData.append(key, params[key])
            }

            const res = await this.$rf
              .getRequest('DoctorRequest')
              .postUploadVideos(formData)
            return { ...video, url: res.data.url }
          })
        )

        return fileUrls?.filter(item => {
          delete item.file
          return item
        })
        //   ?.filter(item => item.status === 'fulfilled')
        //   .map(itemMap => itemMap?.value)
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async getVideosCircle () {
      if (!this.circle?.id) return

      try {
        const params = {
          circle_id: this.circle.id,
          page_num: 1,
          page_size: 1000
        }

        const response = await this.$rf
          .getRequest('DoctorRequest')
          .getVideosCircle(params)

        this.videoData = response.data?.data || []

        let videos = []
        if (this.isAdmin) {
          videos = this.videoData
        } else {
          videos = this.videoData?.filter(item => item?.is_show === 2)
        }

        if (!videos?.length) return

        const resultUrl = await this.handleGetUrlSource(videos[0].url)
        this.playerSources = [
          {
            src: resultUrl,
            type: 'video/mp4',
            label: 'HD'
          }
        ]

        if (
          !this.$refs.CircleVideoPlayer ||
          !this.$refs.CircleVideoPlayer.player
        ) {
          return
        }

        await this.$refs.CircleVideoPlayer.player.updateSrc(this.playerSources)
      } catch (error) {
        console.log(error)
      }
    },
    handleRefresh () {
      this.addVideo = [{ ...DEFAULT_VIDEO }]
      this.isLoading = false
      this.getVideosCircle()
      this.isAdd = false

      if (
        !this.$refs.CircleVideoPlayer ||
        !this.$refs.CircleVideoPlayer.player
      ) {
        return
      }

      this.$refs.CircleVideoPlayer.player.pause()
      //   this.player.player.reset()
    },
    async handleUpdateSrcPlayer (video) {
      if (!video.url) return

      const resultUrl = await this.handleGetUrlSource(video.url)

      this.playerSources = [
        {
          src: resultUrl,
          type: 'video/mp4',
          label: 'HD'
        }
      ]

      if (
        !this.$refs.CircleVideoPlayer ||
        !this.$refs.CircleVideoPlayer.player
      ) {
        return
      }

      await this.$refs.CircleVideoPlayer.player.pause()
      await this.$refs.CircleVideoPlayer.player.reset()
      await this.$refs.CircleVideoPlayer.player.updateSrc(this.playerSources)
    },
    handleUpdateVideo () {
      if (this.videoData.length > 0) {
        this.addVideo = [...this.videoData]
      } else {
        this.addVideo = [
          {
            ...DEFAULT_VIDEO
          }
        ]
      }
      this.isAdd = true
    },
    async handleUploadFilesAWS (fileVideos = []) {
      if (!this.circle?.id) return

      const videos = fileVideos.map(item => item.file)

      const resultUrl = await uploadCircleFile.circleUploadHanlder(
        this.circle.id,
        0,
        videos,
        1,
        true
      )
      return fileVideos?.map((item, index) => ({
        ...item,
        url: resultUrl[index] || item?.url
      }))
    },
    async handleGetUrlSource (url) {
      if (url.includes('resources/circles')) {
        const resultUrl = await uploadCircleFile.getLinkVideoAWS(url)

        return resultUrl
      } else {
        return url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-max-height {
  max-height: 700px;
}

.cs-video-item {
  border: 1px solid #dcd8d8;
  border-radius: 8px;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  padding: 10px;
  cursor: pointer;
}

.cs-button-delete {
  padding: 4px;
  margin: 0 4px;
  border: 1px solid #ea5455;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    outline: #eb9a9a solid 1px;
    box-shadow: -2px -19px 150px 3px #f1b9b9;
    -webkit-box-shadow: -2px -19px 150px 3px #f1b9b9;
    -moz-box-shadow: -2px -19px 150px 3px #f1b9b9;
  }
}

.cs-button-add {
  padding: 4px;
  margin: 0 4px;
  border: 1px solid #345fd3;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    outline: #345fd3 solid 1px;
    box-shadow: -2px -19px 150px 3px #345fd3;
    -webkit-box-shadow: -2px -19px 150px 3px #345fd3;
    -moz-box-shadow: -2px -19px 150px 3px #345fd3;
  }
}

.cs-button-hide {
  padding: 4px;
  margin: 0 4px;
  border: 1px solid #e09030;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    outline: #eaa754 solid 1px;
    box-shadow: -2px -19px 150px 3px #eaa754;
    -webkit-box-shadow: -2px -19px 150px 3px #eaa754;
    -moz-box-shadow: -2px -19px 150px 3px #eaa754;
  }
}

.cs-video-container {
  min-height: 550px;
}

::v-deep {
  .el-dialog__body {
    padding: 20px;
  }
  .el-input__inner {
    border: 1px solid #dcdfe6 !important;
    background-color: white !important;
  }

  .el-input-group__append {
    padding: 0 !important;
    min-width: 60px !important;
    height: 40px !important;
  }

  .video-player-box {
    position: relative;

    &::before {
      content: "";
      display: block;
      padding-top: percentage(1/2);
    }
    .video-js {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
    }

    @mixin transition($args...) {
      -webkit-transition: $args;
      -moz-transition: $args;
      -ms-transition: $args;
      -o-transition: $args;
      transition: $args;
    }

    // Sass for videojs-watermark
    .video-js {
      &.vjs-watermark {
        display: block;
      }
      .vjs-watermark-content {
        opacity: 0.99;
        position: absolute;
        padding: 16px 16px 0 0;
        width: 4rem;
        height: 4rem;
        @include transition(visibility 1s, opacity 1s);
      }

      // pre-defined positions
      .vjs-watermark-top-right {
        right: 0;
        top: 0;
      }
      .vjs-watermark-top-left {
        left: 0;
        top: 0;
      }
      // bottom set to 30px to account for controlbar
      .vjs-watermark-bottom-right {
        right: 0;
        bottom: 30px;
      }
      .vjs-watermark-bottom-left {
        left: 0;
        bottom: 30px;
      }

      //fade out when the user is not active and the video is playing.
      &.vjs-user-inactive.vjs-playing .vjs-watermark-fade {
        opacity: 0;
      }
    }
  }
}
</style>